var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-help"},[_c('div',{staticClass:"sidebar-help"},[_c('iframe',{staticClass:"gdoc",attrs:{"src":_vm.$tera.project.TrialWizard.googleDocBaseURLForHelp,"frameborder":"0"}}),_c('button',{staticClass:"closeButton animated-close",on:{"click":_vm.closeHelp}},[_vm._v("X")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }